import { useTranslate } from "@similarweb/i18n-provider";
import { Table } from "@similarweb/pro-logic-components";
import { SearchInput } from "@similarweb/ui-components";

import type { AppsDigitalAssetRecord } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";
import { digitalAssetTypeMap } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";

import { SearchBoxLoader } from "../../../components/shared/Loader/SearchBoxLoader";
import { getNoData } from "../../../constants";
import { useFilteredDigitalAssetsData } from "../../../hooks/useFilteredDigitalAssetsData";
import { getAppsDigitalAssetsColumns } from "../columns";

import { StyledSearchInputContainer, StyledTableWrapper } from "./styles";

const appsSearchAccessor = (item: AppsDigitalAssetRecord) => item.appName;

export const AppsCardContent = () => {
    const { translate } = useTranslate();

    const { displayedData, isLoading, totalCount, paginationProps, onSearchChange, showSearch } =
        useFilteredDigitalAssetsData({
            assetType: digitalAssetTypeMap.apps,
            getSearchValue: appsSearchAccessor,
        });

    return (
        <section data-automation="digital-assets-apps-table">
            {isLoading ? (
                <SearchBoxLoader />
            ) : showSearch ? (
                <StyledSearchInputContainer>
                    <SearchInput
                        data-automation="digital-assets-apps-search"
                        debounce={300}
                        onChange={onSearchChange}
                        placeholder={`${translate("common.placeholder.search")}...`}
                    />
                </StyledSearchInputContainer>
            ) : null}

            <StyledTableWrapper withBorder={showSearch}>
                <Table
                    isLoading={isLoading}
                    data={displayedData}
                    columnConfig={getAppsDigitalAssetsColumns(totalCount)}
                    pagination={paginationProps}
                    noData={getNoData()}
                    withArrowButtons
                />
            </StyledTableWrapper>
        </section>
    );
};
